import { createContext, useContext, useEffect, useState } from "react";
import { makeRequest } from "../services/api";
import { message } from "antd";
import dayjs from "dayjs";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [sharedData, setSharedData] = useState(null);
    const [dining, setDining] = useState(null);
    const [settings, setSettings] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState('');

    useEffect(() => {
        const getSettings = async () => {
            try {
                const response = await makeRequest('get', '/settings');
                if (response?.data && response.statusCode === 200) {
                    setSettings(response.data)
                } else {
                    throw new Error('Failed to fetch settings');
                }
            } catch (error) {
                message.error(error.message || 'Failed to fetch settings');
            }
        };
        getSettings()
    },[])

    useEffect(() => {
        if(settings?.activeStatus !== null) {
            if(settings?.activeStatus === false) {
                const currentDate = dayjs().startOf('day').valueOf();
                const startDate = dayjs(Number(settings?.startDate)).startOf('day').valueOf();
                const endDate = dayjs(Number(settings?.endDate)).startOf('day').valueOf();

                if (currentDate >= startDate && currentDate <= endDate) {
                    setDisabled(true);
                    const disabledMessage = `The park is closed from ${
                        dayjs(startDate).format("ddd, DD MMM YYYY")
                    } to ${
                        dayjs(endDate).format("ddd, DD MMM YYYY")
                    }. Try booking after this.`;
                    setTooltipMessage(disabledMessage);
                } else {
                    setDisabled(false);
                    setTooltipMessage("");
                }
            }
        }
    },[settings]);

    return (
        <DataContext.Provider value={{ sharedData, setSharedData, dining, setDining, disabled, tooltipMessage, settings }}>
            {children}
        </DataContext.Provider>
    );
};

export const useData = () => useContext(DataContext);
